module.exports = __webpack_public_path__ + "static/uti-9c312e13717234d17252aa62f4ea0edc.jpg";